import {
  Box,
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Text
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { NewProduct } from "models/new_product_type";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { MdAdd, MdSave } from "react-icons/md";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";

interface INewProductForm {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: NewProduct;
  loading: boolean;
  save: () => void;
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  fornecedores: PessoaType[];
  selectedFornecedor: PessoaType[];
  brandStars: string;
  textColor: string;
  changeInput: (type: string, value: any) => void;
  changeFornecedor: (item: any) => void;
}

const NewProductForm = ({
  show,
  showModal,
  loading,
  save,
  accountSelected,
  editPessoa,
  selectedFornecedor,
  showFormPessoa,
  brandStars,
  textColor,
  changeInput,
  fornecedores,
  changeFornecedor,
}: INewProductForm) => {
  const { unidades } = useMeasureUnit();


  return (
    <Box w={"100%"} h={"100%"}>
      <Box
        px="0px"
        mb="16px"
        mt="0px"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={4}>
          <Button
            leftIcon={<MdSave />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
            isLoading={loading}
            onClick={() => save()}
          >
            Salvar
          </Button>
        </Stack>
      </Box>
      <SimpleGrid columns={3} spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Nome do Produto<Text color={brandStars}>*</Text>
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Nome do Produto"
            fontWeight="500"
            defaultValue={accountSelected?.nome}
            size="md"
            autoFocus={true}
            onBlur={(e) => changeInput("nome", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Código SKU<Text color={brandStars}>*</Text>
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Código SKU"
            fontWeight="500"
            defaultValue={accountSelected?.sku}
            size="md"
            onBlur={(e) => changeInput("sku", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor de Venda<Text color={brandStars}>*</Text>
          </FormLabel>

          <NumberInput
            min={0}
            precision={2}
            onChange={(e: string) => {
              changeInput("precoVenda", e);
            }}
            defaultValue={accountSelected?.precoVenda}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Marca<Text color={brandStars}>*</Text>
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Marca"
            fontWeight="500"
            defaultValue={accountSelected?.marca}
            size="md"
            onBlur={(e) => changeInput("marca", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Modelo<Text color={brandStars}>*</Text>
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Modelo"
            fontWeight="500"
            defaultValue={accountSelected?.modelo}
            size="md"
            onBlur={(e) => changeInput("modelo", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Data de Validade
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.dataValidade !== undefined
                ? new Date(accountSelected?.dataValidade)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "dataValidade");
            }}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={3} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            NCM
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o NCM"
            fontWeight="500"
            defaultValue={accountSelected?.ncm}
            size="md"
            onBlur={(e) => changeInput("ncm", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Número de Série
          </FormLabel>
          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Número de Série"
            fontWeight="500"
            defaultValue={accountSelected?.numSerie}
            size="md"
            onBlur={(e) => changeInput("numSerie", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Depreciação %
          </FormLabel>

          <NumberInput
            min={0}
            precision={2}
            onChange={(e: string) => {
              changeInput("depreciacao", e);
            }}
            defaultValue={accountSelected?.depreciacao}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={4} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Unidade<Text color={brandStars}>*</Text>
          </FormLabel>

          <Select
            size="md"
            defaultValue={accountSelected?.unidadeMedidaId}
            placeholder={'Selecione a Unidade de Medida'}
            onChange={(e) => changeInput("unidade", e.target.value)}
          >
            {unidades?.map((item) => (
              <option value={item?.id}>{item?.nome}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Formato
          </FormLabel>

          <Select
            size="md"
            defaultValue={accountSelected?.formato}
            placeholder={'Selecione o Formato'}
            onChange={(e) => changeInput("formato", e.target.value)}
          >
            <option value="VENDA">VENDA</option>
            <option value="PATRIMONIO">PATRIMONIO</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo
          </FormLabel>

          <Select
            size="md"
            defaultValue={accountSelected?.tipo}
            placeholder={'Selecione o Tipo'}
            onChange={(e) => changeInput("tipo", e.target.value)}
          >
            <option value="PRODUTO">PRODUTO</option>
            <option value="SERVIÇO">SERVIÇO</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Condição
          </FormLabel>

          <Select
            size="md"
            defaultValue={accountSelected?.condicao}
            onChange={(e) => changeInput("condicao", e.target.value)}
            placeholder={'Selecione a Condição'}
          >
            <option value="NOVO">NOVO</option>
            <option value="USADO">USADO</option>
          </Select>
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={1} spacing={4} mt={4} mb={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Fornecedores
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <Box w={"97%"}>
              <AutoComplete<OptionType, true, GroupBase<OptionType>>
                size="md"
                onChange={(e) => {
                  changeFornecedor(e);
                }}
                placeholder="Selecione os Fornecedores"
                name={"Filial"}
                tagVariant="solid"
                colorScheme="brand"
                isMulti
                value={selectedFornecedor.map((pf) => {
                  return {
                    value: pf?.id,
                    label: pf?.nome,
                  };
                })}
                options={fornecedores?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>

            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              size={"md"}
              icon={<MdAdd />}
              onClick={() => showFormPessoa(true)}
              float={"right"}
              aria-label={"Adicionar Cliente"}
            />
          </Box>
        </FormControl>
      </SimpleGrid>
    </Box>
  );
};
export default NewProductForm;
